import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Modal } from 'antd'
import './index.css'
import { formateDate } from '../../utils/dateUtils'
import storageUtils from '../../utils/storageUtils'
import LinkButton from '../link-button'
import { connect } from 'react-redux'
import { logout } from '../../redux/actions'

class Header extends Component {
  state = {
    currentTime: formateDate(Date.now()),
  }

  /**
   * 退出登录
   */
  logout = () => {
    Modal.confirm({
      content: '确定退出吗？',
      onOk: () => {
        this.props.logout()
      },
    })
  }

  /**
   * 显示时间
   */
  getTime = () => {
    this.intervalId = setInterval(() => {
      const currentTime = formateDate(Date.now())
      this.setState({ currentTime })
    }, 1000)
  }

  componentDidMount() {
    this.getTime()
  }

  /**
   * 清除定时器
   */
  componentWillUnmount() {
    clearInterval(this.intervalId)
  }
  render() {
    const { currentTime } = this.state
    const { uid } = storageUtils.getUser()
    const title = this.props.headTitle
    return (
      <div className="header">
        <div className="header-top">
          <span>欢迎！{uid}</span>
          <LinkButton href="#" onClick={this.logout}>
            退出
          </LinkButton>
        </div>
        <div className="header-bottom">
          <div className="header-bottom-left">{title}</div>
          <div className="header-bottom-right">
            <span>{currentTime}</span>
            {/* <img
              src="http://api.map.baidu.com/images/weather/day/qing.png"
              alt=""
            />
            <span>晴</span> */}
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state) => ({ headTitle: state.headTitle }), { logout })(
  withRouter(Header)
)
